import { Injectable, Injector } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Router } from '@angular/router';

import { Observable, of, BehaviorSubject } from 'rxjs';
import { catchError, switchMap, filter, take } from 'rxjs/operators';

import { JwtTokenService } from '../services/jwtToken.service';
import { UserService } from '../services/user.service';

declare var alertify: any;
@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  urlsToNotUse: Array<string>;
  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );

  constructor(
    private router: Router,
    private jwtService: JwtTokenService,
    private userService: UserService
  ) {
    this.urlsToNotUse = ['amazonaws.com/.+'];
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const headersConfig: any = {
      //'Content-Type': 'application/json',
      Accept: 'application/json',
    };

    // Handle presigned URL requests
    if (this.isPresignedUrl(req.url)) {
      console.log('Presigned URL request bypassed:', req.url);
      return next.handle(req);
    }

    if (req.url.indexOf('/auth/refresh-access-token/') > -1) {
      const token = this.jwtService.getRefreshToken();

      if (token) {
        headersConfig['Authorization'] = `Bearer ${token}`;
      }

      const request = req.clone({ setHeaders: headersConfig });

      return next.handle(request).pipe(
        catchError((error, caught) => {
          return this.handleAuthError(error, req, next);
        }) as any
      );
    } else if (this.isValidRequestForInterceptor(req.url)) {
      const token = this.jwtService.getToken();

      console.log('called from here', token);

      if (token) {
        headersConfig['Authorization'] = `Bearer ${token}`;
      }

      const request = req.clone({ setHeaders: headersConfig });

      return next.handle(request).pipe(
        catchError((error, caught) => {
          return this.handleAuthError(error, req, next);
        }) as any
      );
    } else if (this.isLogoutRequest(req.url)) {
      const token = this.jwtService.getToken();

      if (token) {
        headersConfig['AUTHORIZATION'] = `Bearer ${token}`;
      }
      const request = req.clone({ setHeaders: headersConfig });
      return next.handle(request).pipe(
        catchError((error, caught) => {
          return this.handleAuthError(error, req, next);
        }) as any
      );
    }

    return next.handle(req);
  }

  private isPresignedUrl(url: string): boolean {
    // Add any additional presigned URL patterns here if needed
    const presignedUrlPatterns = ['amazonaws.com/', 's3.amazonaws.com/'];
    return presignedUrlPatterns.some((pattern) => url.includes(pattern));
  }

  private isValidRequestForInterceptor(requestUrl: string): boolean {
    const positionIndicator = 'amazonaws.com/';
    const position = requestUrl.indexOf(positionIndicator);

    if (position > 0) {
      return false;
    }

    return true;
  }

  private isLogoutRequest(requestUrl: string): boolean {
    const positionIndicator = 'logout';
    const position = requestUrl.indexOf(positionIndicator);

    if (position > 0) {
      return false;
    }
    return true;
  }

  private handleAuthError(
    err: HttpErrorResponse,
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<any> {
    console.log(err?.error, 'handleAuthError');
    console.log(err?.status, 'handleAuthError');
    if (
      err &&
      err?.error &&
      err?.error?.status_type === 'RESPONSE_STATUS_FORCE_LOGOUT'
    ) {
      console.log('ggwp');
      this.userService.deleteAuthCredentials();
      alertify.set('notifier', 'position', 'top-right');
      alertify.notify('Session expired, please login', 'error');
      this.router.navigateByUrl('/login');
      return of(err.message);
    } else if (
      err.status === 403 &&
      err.error?.status_type === 'RESPONSE_STATUS_SESSION_EXPIRED'
    ) {
      console.log('inside 403 navigation');
      return this.handle403Error(request, next);
    } else if (
      (err &&
        err.error &&
        err.error?.status_type === 'RESPONSE_STATUS_FORCE_LOGOUT') ||
      err.error?.status_type === 'RESPONSE_STATUS_UNAUTHORIZED'
    ) {
      console.log('inside RESPONSE_STATUS_UNAUTHORIZED navigation');
      this.userService.deleteAuthCredentials();
      alertify.set('notifier', 'position', 'top-right');
      alertify.notify('Session expired, please login', 'error');
      this.router.navigateByUrl('/login');
      return of(err.message);
    }

    throw err;
  }

  private addTokenHeader(request: HttpRequest<any>, token: string) {
    return request.clone({
      headers: request.headers.set('Authorization', `Bearer ${token}`),
    });
  }

  private handle403Error(request: HttpRequest<any>, next: HttpHandler) {
    console.log('aaaasdfdffffff', this.isRefreshing);
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);
      console.log('adnfjfjfj', this.isRefreshing);
      return this.userService.refreshAccessToken().pipe(
        switchMap((data: any) => {
          this.isRefreshing = false;
          console.log('adnfjfjfj', data, request);
          this.jwtService.saveToken(data.results.token);
          this.refreshTokenSubject.next(data);
          return next.handle(this.addTokenHeader(request, data.results.token));
        })
      );
    } else {
      console.log(
        'ajddjjdjdjdjjdjd',
        this.isRefreshing,
        this.refreshTokenSubject?.value
      );
      return this.refreshTokenSubject.pipe(
        filter((data) => data != null),
        take(1),
        switchMap((data) => {
          const headersConfig: any = {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          };
          console.log(data.results.token, 'data.results.token', data);
          if (
            data.results.token &&
            this.isValidRequestForInterceptor(request.url)
          ) {
            headersConfig['Authorization'] = `Bearer ${data.results.token}`;
          }
          const req = request.clone({ setHeaders: headersConfig });

          return next.handle(req);
        })
      );
    }
  }
}
